import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { Logo, Monogram } from "./Logo";

const cols = [
  { title: "Shop", links: [["Shop All", "/shop"], ["Fashion", "/shop?category=Fashion"], ["Accessories", "/shop?category=Accessories"], ["Home & Living", "/shop?category=Home%20%26%20Living"], ["Gifts", "/shop?category=Gifts"]] },
  { title: "Discover", links: [["New Arrivals", "/shop?tag=new"], ["Sale", "/shop?tag=sale"], ["Wishlist", "/wishlist"], ["Your Bag", "/cart"]] },
  { title: "Help", links: [["About Us", "/help#about"], ["Shipping", "/help#shipping"], ["Returns", "/help#returns"], ["FAQ", "/help#faq"], ["Contact", "/help#contact"]] },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-plum-deep text-cream pb-24 md:pb-0">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 sm:px-8 py-20 lg:grid-cols-[1.3fr_2fr]">
      <div className="flex flex-col items-start gap-6">
        <Logo tone="light" testId="footer-logo" />
        <p className="font-script text-4xl text-gold-light">More than a store... it's a lifestyle.</p>
        <div className="flex gap-3">
          {[[Facebook, "facebook"], [Instagram, "instagram"], [Youtube, "youtube"]].map(([Icon, n]) => (
            <a key={n} href="#" aria-label={n} data-testid={`footer-social-${n}`} className="grid h-11 w-11 place-items-center rounded-full border border-cream/20 transition-colors hover:border-gold hover:text-gold">
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
        {cols.map((c) => (
          <div key={c.title}>
            <p className="eyebrow text-gold">{c.title}</p>
            <ul className="mt-5 space-y-3">
              {c.links.map(([l, to]) => (
                <li key={l}>
                  <Link to={to} data-testid={`footer-link-${c.title.toLowerCase()}-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-cream/80 transition-colors hover:text-gold-light">{l}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
    <div className="border-t border-cream/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 sm:px-8 py-6 sm:flex-row">
        <p className="eyebrow text-[10px] text-cream/70">© {new Date().getFullYear()} Luxe Dream Market · Style • Living • Everyday Luxe</p>
        <Monogram className="w-14 h-14 text-[10px]" />
      </div>
    </div>
  </footer>
);
